import React, { useState } from 'react';
import { FiMail, FiLock, FiUser } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import { register } from '../../../services/auth';
import { setToken } from '../../../utils/token';
import { Notify } from 'notiflix';
//ToDo: buradaki inputlar next ui input ile değiştirilcek.
function RegisterComponent() {
  const navigate = useNavigate();
  const [ufname, setUfname] = useState('')
  const [ulname, setUlname] = useState('')
  const [umail, setUmail] = useState('')
  const [upass, setUpass] = useState('')

  const handleRegister = async () => {
    try {
      const response = await register({
        ufname: ufname,
        ulname: ulname,
        umail: umail,
        upass: upass
      });
      
      
      if (response && response.accessToken) {
        // Token varsa direkt dashboard'a yönlendir
        setToken('penatoken', response.accessToken);
        setToken('user', JSON.stringify(response.user));
        Notify.success('Hesabınız başarıyla oluşturuldu!');
        navigate('/dashboard');
      } else if (response && response.message && response.message.includes('başarılı')) {
        // Başarılı mesajı varsa login'e yönlendir
        Notify.success(response.message);
        navigate('/login');
      } else if (response && response.message) {
        // Diğer mesajları hata olarak göster
        Notify.failure(response.message, { position: 'right-bottom' });
      } else {
        Notify.failure('Kayıt işlemi başarısız oldu.');
      }
    } catch (error) {
      console.error('Register error:', error);
      
      // API'den gelen hata mesajını kontrol et
      if (error.response && error.response.data && error.response.data.message) {
        Notify.failure(error.response.data.message, { position: 'right-bottom' });
      } else if (error.response && error.response.data && error.response.data.errors) {
        // Validation hatalarını göster
        const errorMessages = Object.values(error.response.data.errors).flat();
        Notify.failure(errorMessages.join(', '), { position: 'right-bottom' });
      } else {
        Notify.failure('Kayıt işlemi sırasında bir hata oluştu.', { position: 'right-bottom' });
      }
    }
  }

  return (
    <div className="h-screen flex justify-center bg-[#fdfdfd]">
      <div className="flex w-1/3 justify-end items-center bg-white">
        <form className="bg-white ">
          <h1 className="text-red-600 text-3xl ">Kayıt Ol</h1>
          <p className="text-sm font-normal text-gray-600 mb-10 my-4">Kayıt olmak için formu kullanabilirsin.</p>
          <div className="flex w-80 h-[60px] items-center border-2 py-2 px-3 rounded-2xl mb-5">
            <FiUser className="h-5 w-5 text-gray-400" />
            <input className="pl-2 outline-none border-none" onChange={(e) => setUfname(e.target.value)} value={ufname} type="text" name="ufname" id="" placeholder="Adınız" />
          </div>
          <div className="flex w-80 h-[60px] items-center border-2 py-2 px-3 rounded-2xl mb-5">
            <FiUser className="h-5 w-5 text-gray-400" />
            <input className="pl-2 outline-none border-none" onChange={(e) => setUlname(e.target.value)} value={ulname} type="text" name="ulname" id="" placeholder="Soyadınız" />
          </div>
          <div className="flex w-80 h-[60px] items-center border-2 py-2 px-3 rounded-2xl mb-5">
            <FiMail className="h-5 w-5 text-gray-400" />
            <input className="pl-2 outline-none border-none" onChange={(e) => setUmail(e.target.value)} value={umail} type="text" name="umail" id="" placeholder="E-Posta" />
          </div>
          <div className="flex my-4 w-80 h-[60px] items-center border-2 py-2 px-3 rounded-2xl">
            <FiLock className="h-5 w-5 text-gray-400" />
            <input className="pl-2 outline-none border-none" onChange={(e) => setUpass(e.target.value)} value={upass} type="password" name="" id="upass" placeholder="Şifre" />
          </div>

          <div className="flex justify-between">
            <button onClick={handleRegister} type="button" className="block w-[150px] h-[45px] rounded-full bg-red-600 mt-4 py-2 rounded-2xl text-white text-sm mb-2">
              Hesap Oluştur
            </button>

            <div className="flex mr-8 mt-6 ltr:ml-auto rtl:mr-auto">
              <p className="mr-2 text-gray-800">ya da</p>
              <Link to="/login" className="text-red-600 dark:text-gray-100 hover:text-red-700 dark:hover:text-gray-200 transition-colors">
                Giriş Yap.
              </Link>
            </div>
          </div>
        </form>
      </div>
      <div className="flex w-2/3 justify-start">
        <img src="/assets/loginpg.svg" alt="Logo" className="max-w-[600px] w-full mx-auto h-auto" />
      </div>
    </div>
  )
}
export default RegisterComponent
